export default "__VITE_ASSET__DnLbDhxD__"